const updates = [
  {
    date: '2026-08-01',
    title: '《流浪地球3》超清版上线',
    desc: '国产科幻巨制高清版本现已上线，4K超清画质，全集播放不缓冲。',
    tag: '电影',
  },
  {
    date: '2026-07-31',
    title: '《庆余年2》全集更新完毕',
    desc: '第二季全36集高清版本全部上线，无需等待，一口气刷完。',
    tag: '剧集',
  },
  {
    date: '2026-07-30',
    title: '暑期档专题合集上线',
    desc: '精选暑期热门大片与高分剧集，一页尽览夏日观影指南。',
    tag: '专题',
  },
  {
    date: '2026-07-29',
    title: '纪录片频道新增50部精品',
    desc: 'BBC、央视等顶级纪录片高清资源更新，涵盖自然、历史、科技。',
    tag: '纪录',
  },
  {
    date: '2026-07-28',
    title: '移动端播放体验全面优化',
    desc: '手机观影画质提升，流量消耗降低30%，超清画质依然秒开。',
    tag: '优化',
  },
  {
    date: '2026-07-27',
    title: '《狂飙》4K修复版上线',
    desc: '现象级涉案剧高清修复版本，重温经典，画质更上一层楼。',
    tag: '剧集',
  },
  {
    date: '2026-07-26',
    title: '动漫番剧专区扩容',
    desc: '新增上百部国漫、日漫高清资源，二次元影迷的追番天堂。',
    tag: '动漫',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">最新更新</h2>
          <p className="mt-2 text-sm text-foreground-500">影视资源实时更新动态，好片不错过</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={idx} className="flex gap-4 pb-5 relative">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5"></div>
                {idx < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 pb-2">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-md whitespace-nowrap">{item.tag}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}